let urls = 'http://localhost:8080/'
let spaUrl = location.origin
let kcUrl = 'https://homolog.ufms.br/keycloak-homolog'

if (window.location.hostname.includes('homolog')) {
    urls = 'https://homolog.ufms.br/siai/api/'
    spaUrl += '/siai/avaliacao-institucional'
}

if (window.location.hostname.includes('siai.ufms.br')) {
    urls = 'https://siai.ufms.br/avaliacao-institucional/api/'
    kcUrl = 'https://login.ufms.br/auth'
    spaUrl += '/avaliacao-institucional'
}

export default {apiUrl: urls, spaUrl: spaUrl, kcUrl: kcUrl}
